import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import Session from '../auth/Session';
import AdminFunctions from './AdminFunctions';
import '../layout/site.css';

const ROLE_OPTIONS = ['CSR', 'Admin'];

export class UserDetails extends Component {
    static displayName = UserDetails.name;

    constructor(props) {
        super(props);

        this.state = {
            userId: null,
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            role: 'CSR',
            errors: {},
            success: undefined,
            saving: false,
        };
    }

    async componentDidMount() {
        const isAdmin = await AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
            return;
        }

        if (this.props.location.state?.existingUser) {
            const userId = this.props.location.state.userId;
            this.setState({ userId });
            this.getUserDetails(userId);
        }
    }

    render() {
        const { firstName, lastName, email, password, role, userId, success, saving, errors } = this.state;

        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>{userId ? 'Edit User' : 'Add User'}</h3>
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='6'>
                            <input
                                type='text'
                                value={firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name='firstName'
                                id='firstName'
                                placeholder='First Name'
                            />
                            {errors.firstName && <span className="error-text field-error">{errors.firstName}</span>}
                        </Col>
                        <Col xs='6'>
                            <input
                                type='text'
                                value={lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name='lastName'
                                id='lastName'
                                placeholder='Last Name'
                            />
                            {errors.lastName && <span className="error-text field-error">{errors.lastName}</span>}
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='6'>
                            <input
                                type='email'
                                value={email}
                                onChange={(e) => this.setState({ email: e.target.value })}
                                name='email'
                                id='email'
                                placeholder='Email'
                            />
                            {errors.email && <span className="error-text field-error">{errors.email}</span>}
                        </Col>
                        <Col xs='6'>
                            <select
                                type='select'
                                value={role}
                                onChange={(e) => this.setState({ role: e.target.value })}
                                name='role'
                                id='role'
                            >
                                {ROLE_OPTIONS.map((r) => (
                                    <option key={r} value={r}>{r}</option>
                                ))}
                            </select>
                        </Col>
                    </Row>

                    {!userId && (
                        <Row className='row-10'>
                            <Col xs='6'>
                                <input
                                    type='password'
                                    value={password}
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                    name='password'
                                    id='password'
                                    placeholder='Password'
                                />
                                {errors.password && <span className="error-text field-error">{errors.password}</span>}
                            </Col>
                        </Row>
                    )}

                    <Row className='row-20'>
                        <Col xs='6'>
                            <Button
                                color='primary'
                                disabled={saving}
                                onClick={() => this.handleSave()}
                            >
                                {saving ? 'Saving...' : 'Save'}
                            </Button>
                        </Col>
                    </Row>

                    <Row className='row-20'>
                        <Col>
                            {success === true && (
                                <Alert color='success'>
                                    {userId ? 'User updated successfully!' : 'User added successfully!'}
                                </Alert>
                            )}
                            {success === false && (
                                <Alert color='danger'>
                                    {userId ? 'Error updating user.' : 'Error adding user'}
                                </Alert>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    async getUserDetails(userId) {
        const token = Session.getToken();

        const response = await fetch(`api/Admin/GetUserDetailsAsync?id=${userId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            email: data.email || '',
            role: data.role === 'Admin' ? 'Admin' : 'CSR',
        });
    }

    validate() {
        const errors = {};
        if (!this.state.firstName.trim()) errors.firstName = 'First name is required.';
        if (!this.state.lastName.trim()) errors.lastName = 'Last name is required.';
        if (!this.state.email.trim()) errors.email = 'Email is required.';
        if (!this.state.email.includes('@')) errors.email = 'Email is required.';
        if (!this.state.userId && !this.state.password.trim()) errors.password = 'Password is required.';
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    async handleSave() {
        if (!this.validate()) return;

        this.setState({ saving: true, success: undefined });
        const token = Session.getToken();

        if (this.state.userId) {
            const dto = {
                id: this.state.userId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                role: this.state.role,
            };
            await this.editUser(dto, token);
        } else {
            const dto = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                password: this.state.password,
                role: this.state.role,
            };
            await this.createUser(dto, token);
        }

        this.setState({ saving: false });
    }

    async editUser(dto, token) {
        try {
            const response = await fetch('api/Admin/EditUserAsync', {
                method: 'POST',
                body: JSON.stringify(dto),
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            this.setState({ success: !!data });
        } catch (err) {
            this.setState({ success: false });
        }
    }

    async createUser(dto, token) {
        try {
            const response = await fetch('api/Admin/CreateCSRUser', {
                method: 'POST',
                body: JSON.stringify(dto),
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            this.setState({ success: response.ok });
        } catch (err) {
            this.setState({ success: false });
        }
    }
}